// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"8":"b8ce2d94","24":"4445630f","71":"cdfaa890","249":"b8080f13"}[chunkId] + ".js";
};